import { decimal } from '@utils/filters'
import evaluateSpecScore from './evaluateSpecScore'
import { getRandomItemUnique } from '@utils/collections'

const randomPhrase = getRandomItemUnique

export const specLabel = (specKey, specLabel, suffix = '') => (phrases, laptop) => [
  randomPhrase(phrases),
  specLabel,
  `(${laptop[specKey]}${suffix})`,
].join(' ')

export const getRandomProsConsPhrases = (prosCons, articleLaptopsContext) => prosCons
  .map(method =>
    method(articleLaptopsContext) &&
    randomPhrase(method(articleLaptopsContext)))
  .filter(Boolean)

const under = boundary => score => score > 0 && score < boundary
const above = boundary => score => score >= boundary

export const basicPros = (() => {
  const prosPhrases = [
    {
      condition: above(7),
      phrases: [
        'Awesome',
        'Excellent',
        'Exceptional',
        'First-class',
        'Great',
        'Solid',
        'Splendid',
        'Superb',
        'Terrific',
        'Very good',
      ],
    },
    {
      condition: above(4),
      phrases: [
        'Adequate',
        'Competent',
        'Decent',
        'Fair',
        'Good',
        'Sufficient',
        'Up to scratch',
        'Up to the mark',
      ],
    },
  ]

  return evaluateSpecScore(prosPhrases)
})()

export const basicCons = (() => {
  const consPhrases = [
    {
      condition: under(3),
      phrases: [
        'Garden-variety',
        'Mediocre',
        'Middle-of-the-road',
        'Not the best',
        'Ordinary',
        'Run-of-the-mill',
        'So-so',
        'Average',
        'Unexceptional',
        'Substandard',
        'Underwhelming',
        'Unremarkable',
      ],
    },
  ]

  return evaluateSpecScore(consPhrases)
})()

export const [weightPros, weightCons] = (() => {
  const MID = 4
  const LIGHT = 7
  const VERY_LIGHT = 9

  const pros = [
    {
      condition: above(VERY_LIGHT),
      phrases: [
        'Featherweight',
      ],
    },
    {
      condition: above(LIGHT),
      phrases: [
        'Lightweight',
        'Thin',
        'Featherweight',
        'Light-weight',
        'Light',
      ],
    },
  ]

  const cons = [
    {
      condition: under(MID),
      phrases: [
        'Heavy',
        'Weighty',
        'Bulky',
      ],
    },
  ]

  const displayWeight = (phrases, { weight }) => {
    const weightLbs = Number(decimal(weight * 2.2))

    return `${randomPhrase(phrases)} (${weightLbs} lbs)`
  }

  return [pros, cons]
    .map(prosCons => evaluateSpecScore(prosCons)(
      'weight',
      displayWeight,
      true,
    ))
})()
